import type { SVGProps } from "react";

/**
 * Roast / bake — oven rack with flames underneath.
 */
export function RoastIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Oven body */}
      <rect
        x={4}
        y={10}
        width={40}
        height={32}
        rx={4}
        fill="currentColor"
        opacity={0.1}
      />
      <rect
        x={4}
        y={10}
        width={40}
        height={32}
        rx={4}
        stroke="currentColor"
        strokeWidth={1.5}
        opacity={0.3}
        fill="none"
      />
      {/* Glass window */}
      <rect
        x={10}
        y={16}
        width={28}
        height={20}
        rx={2}
        fill="currentColor"
        opacity={0.08}
      />
      {/* Rack */}
      <line
        x1={10}
        y1={28}
        x2={38}
        y2={28}
        stroke="currentColor"
        strokeWidth={1}
        opacity={0.3}
      />
      <line
        x1={16}
        y1={16}
        x2={16}
        y2={36}
        stroke="currentColor"
        strokeWidth={0.5}
        opacity={0.15}
      />
      <line
        x1={24}
        y1={16}
        x2={24}
        y2={36}
        stroke="currentColor"
        strokeWidth={0.5}
        opacity={0.15}
      />
      <line
        x1={32}
        y1={16}
        x2={32}
        y2={36}
        stroke="currentColor"
        strokeWidth={0.5}
        opacity={0.15}
      />
      {/* Flame / heat lines at bottom */}
      <path
        d="M14 40c1-2 2-2 3-4"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        opacity={0.5}
        fill="none"
      />
      <path
        d="M20 40c1-2 2-3 3-4"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        opacity={0.4}
        fill="none"
      />
      <path
        d="M26 40c1-2 2-2 3-4"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        opacity={0.5}
        fill="none"
      />
      <path
        d="M32 40c1-2 2-3 3-4"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        opacity={0.4}
        fill="none"
      />
    </svg>
  );
}
